


<div class="bg-gradient-primary">
    <div class="container">
      <!-- Outer Row -->
      <div class="row justify-content-center">
        <div class="col-xl-10 col-lg-12 col-md-9">
          <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
              <!-- Nested Row within Card Body -->
              <div class="row">
                <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div class="col-lg-6">
                  <div class="p-5">
                    <div class="text-center">
                      <div>
                        <img
                          style="object-fit: cover"
                          [src]="retrievedImage"
                        />
                        <br /><br />
                      </div>
                      <div class="text-center">
                        <h1 class="h4 text-gray-900 mb-2">Forgot Your Password?</h1>
                        <p class="mb-4">We get it, stuff happens. Just enter your email address below
                            and we'll send you a link to reset your password!</p>
                    </div>
                    </div>
  
                    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" novalidate class="user">
                        <div class="form-group">
                            <input type="email" formControlName="email" class="form-control form-control-user" id="exampleInputEmail"
                                   placeholder="Enter your email address"
                                   [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                <div *ngIf="f.email.errors.required">Email is required</div>
                                <div *ngIf="f.email.errors.email">Please enter a valid email</div>
                            </div>
                        </div>
                    
                        <button type="submit" class="btn btn-primary btn-user btn-block">
                            Reset Password
                        </button>
                    
                        <hr>
                      
                    </form>
                    <br>
                    <div class="text-center">
                    <a class="small" routerLink="/login"
                      >Login</a
                    >
                  </div>
                  <div class="text-center">
                    <a class="small" 
                    routerLink="/register">Create an Account</a>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
